import { MapPin, FlaskConical, ArrowRight, Shield, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';
import AdminNavigation from '@/components/AdminNavigation';

export default function AdminSettings() {
  const settingsCards = [
    { title: 'Stasjonar', desc: 'Overvåkingsområde og prøvestasjonar', icon: MapPin, path: '/admin/locations', color: 'bg-teal-500' },
    { title: 'Organismar', desc: 'Algar, zooplankton og grenseverdiar', icon: FlaskConical, path: '/admin/organisms', color: 'bg-emerald-500' },
    { title: 'Administratorar', desc: 'Administrer admin-brukarar og tilgangar', icon: Shield, path: '/admin/administrators', color: 'bg-indigo-500' },
    { title: 'Sikkerheit', desc: 'To-faktor autentisering og kontosikkerheit', icon: ShieldCheck, path: '/admin/security', color: 'bg-amber-500' },
  ];

  return (
    <div className="min-h-screen bg-slate-50 flex">
      <AdminNavigation />
      <main className="flex-1 p-4 lg:p-8 overflow-x-hidden">
        <div className="max-w-4xl mx-auto">
          <div className="mb-8">
            <h1 className="text-2xl font-bold text-slate-900">Innstillingar</h1>
            <p className="text-sm text-slate-500 mt-1">System, brukarar og sikkerheit</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {settingsCards.map(({ title, desc, icon: Icon, path, color }) => (
              <Link key={path} to={path} className="group" data-testid={`settings-card-${path.split('/').pop()}`}>
                <div className="flex items-center gap-4 p-4 bg-white border border-slate-200 rounded-xl hover:border-teal-300 hover:shadow-md transition-all">
                  <div className={`w-10 h-10 ${color} rounded-lg flex items-center justify-center shrink-0`}>
                    <Icon className="w-5 h-5 text-white" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm font-semibold text-slate-900">{title}</h3>
                    <p className="text-xs text-slate-500 truncate">{desc}</p>
                  </div>
                  <ArrowRight className="w-4 h-4 text-slate-300 group-hover:text-teal-500 group-hover:translate-x-0.5 transition-all shrink-0" />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
}
